document.addEventListener('DOMContentLoaded', function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  window.addEventListener('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
    // AOS.refresh();
  });

  // mobilní menu
  function switchMenu() {
    var navSwitcher = document.querySelector('.nav-switcher');
    var nav = document.querySelector('.nav');
    var body = document.body;
    // označíme zda je menu zavřeno či nikoliv
    if (navSwitcher.classList.contains('is-open')) {
      navSwitcher.classList.remove('is-open');
      nav.classList.remove('is-open');
      body.classList.remove('is-unscrollable');
    } else {
      navSwitcher.classList.add('is-open');
      nav.classList.add('is-open');
      body.classList.add('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    var navSwitcher = document.querySelector('.nav-switcher');
    var nav = document.querySelector('.nav');
    navSwitcher.classList.remove('is-open');
    nav.classList.remove('is-open');
    document.body.classList.remove('is-unscrollable');
  }
  // spouštěč
  var navSwitcher = document.querySelector('.nav-switcher');
  if (navSwitcher) {
    navSwitcher.addEventListener('click', function () {
      switchMenu();
    });
  }

  // události při scroolování
  window.addEventListener('scroll', function () {
    //...
  });

  window.addEventListener('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
  });
});
